import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconBadgeComponent } from '../icon-badge/icon-badge.component';
import { IIconData } from './icon-badge-list.interface';

@Component({
  imports: [IconBadgeComponent, MatTooltipModule],
  selector: 'app-icon-badge-list',
  styleUrl: './icon-badge-list.component.scss',
  templateUrl: './icon-badge-list.component.html',
})
export class IconBadgeListComponent {
  public iconData = input.required<IIconData[]>();

  public shownIconsCount = input<number>(3);
  public backgroundColor = input<string>('var(--shikenso-gray-base)');
  public fallbackBackgroundColor = input<string>('var(--shikenso-gray-base)');
  public borderRadius = input<number>(8);
  public borderWidth = input<number>(2);
  public borderColor = input<string | null>('var(--shikenso-base-white)');
  public size = input<number>(24);
  public iconSize = input<number>(14);
  public fontSize = input<number>(14);

  public readonly displayedIconsCount = computed(() => {
    const totalIcons = this.iconData().length;
    const maxShown = this.shownIconsCount();

    if (totalIcons <= maxShown) {
      return totalIcons;
    }

    return maxShown - 1;
  });

  public readonly moreCreatorsCount = computed(() => {
    const totalIcons = this.iconData().length;
    const displayed = this.displayedIconsCount();
    const remaining = totalIcons - displayed;

    if (remaining <= 0) {
      return '';
    }

    return `+${remaining}`;
  });

  public readonly moreCreatorsTooltip = computed(() =>
    this.iconData()
      .slice(this.displayedIconsCount())
      .map((icon) => icon.name)
      .join(',\n')
      .trim(),
  );

  public readonly hasMoreIcons = computed(() => {
    const totalIcons = this.iconData().length;
    const displayed = this.displayedIconsCount();

    return totalIcons > displayed;
  });

  public readonly marginRight = computed(() => {
    if (this.size() === 40) {
      return -12;
    }

    if (this.size() === 32) {
      return -8;
    }

    return -4;
  });

  public readonly moreCreatorsCountFontSize = computed(() => {
    if (this.size() === 40) {
      return 14;
    }

    if (this.size() === 32) {
      return 12;
    }

    if (this.size() === 16) {
      return 8;
    }

    return 10;
  });
}
